import InteractRoutes from './interact';
import MineRoutes from './mine';
import SimpleRoutes from './simple_index';
import SongListRoutes from './song_list';
import ValueAddRoutes from './value_add';
import OrderFood from './order';
import AiRoutes from './ai';
import Photo from './photo'

export default [
  {
    path: '/',
    name: 'index',
    redirect: '/thunder/home',
  },
  {
    path: '/thunder/home',
    name: 'home',
    component: () => import('@/views/index/index.vue'),
    meta: {
      title: '手机点歌',
      level: 1,
    },
    children: [
      {
        path: 'classify_singer',
        name: 'HOME_SINGER',
        component: () => import('@/views/song_list/singer_list_v2.vue'),
        meta: {
          level: 1,
          keepAlive: 1,
        },
      },
      {
        path: 'topsHome',
        name: 'HOME_TOPS',
        component: () => import('@/views/song_list/tops_song.vue'),
        meta: {
          level: 1,
        },
      },
      {
        path: 'topsHomeLR',
        name: 'HOME_TOPS_LR',
        component: () => import('@/views/song_list/tops_song_lr.vue'),
        meta: {
          level: 1,
        },
      },
      {
        path: 'topsVHot',
        name: 'HOME_VHOT',
        component: () => import('@/views/song_list/tops_song.vue'),
        meta: {
          level: 1,
        },
      },
      {
        path: 'topsVHotLR',
        name: 'HOME_VHOT_LR',
        component: () => import('@/views/song_list/tops_song_lr.vue'),
        meta: {
          level: 1,
        },
      },
    ]
  },
  {
    path: '/thunder/code',
    name: 'code',
    component: () => import('@/views/other/code.vue'),
    meta: {
      title: '手机点歌',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/feedback',
    name: 'feedback',
    component: () => import('@/views/mine/feedback.vue'),
    meta: {
      title: '反馈建议',
    },
  },
  {
    path: '/thunder/intercept',
    name: 'intercept',
    component: () => import('@/views/mine/intercept.vue'),
    meta: {
      title: '抱歉,出错了～',
    },
  },
  {
    path: '/thunder/nobind',
    name: 'nobind',
    component: () => import('@/views/other/no_bind'),
    meta: {
      title: '房台码失效',
    },
  },
  {
    path: '/thunder/search/feedback',
    name: 'nosong',
    component: () => import('@/views/feedback/nosong'),
    meta: {
      title: '缺歌反馈',
    },
  },
  // 帮助中心
  {
    path: '/thunder/help',
    component: () => import('@/views/mine/help/help.vue'),
    name: 'help',
    meta: {
      title: '帮助中心',
    },
  },
  {
    path: '/thunder/help_new',
    component: () => import('@/views/mine/help/help_new.vue'),
    name: 'help_new',
    meta: {
      title: '帮助中心',
    },
  },
  {
    path: '/thunder/help/vip',
    component: () => import('@/views/mine/help/help_vip.vue'),
    name: 'help_vip',
    meta: {
      title: '帮助中心',
    },
  },
  {
    path: '/thunder/help/scode',
    component: () => import('@/views/mine/help/help_scode.vue'),
    name: 'help_scode',
    meta: {
      title: '帮助中心',
    },
  },
  {
    path: '/thunder/help/adtoggle',
    component: () => import('@/views/mine/help/help_adtoggle.vue'),
    name: 'help_adtoggle',
    meta: {
      title: '广告带看',
    },
  },
  {
    path: '/thunder/help/refund',
    component: () => import('@/views/mine/help/help_refund.vue'),
    name: 'help_refund',
    meta: {
      title: '订单如何申请退款',
    },
  },
  {
    path: '/thunder/play_ktv2',
    component: () => import('@/views/mine/help/play_ktv.vue'),
    name: 'paly_ktv2',
    meta: {
      title: '玩转ktv',
    },
  },
  // VIP充值用户协议
  {
    path: '/thunder/argument',
    component: () => import('@/views/argument/argument.vue'),
    name: 'argument',
    meta: {
      title: '服务协议',
    },
  },
  {
    path: '/thunder/invite',
    component: () => import('@/views/invite/invite.vue'),
    name: 'invite',
    meta: {
      title: '邀请好友手机点歌',
    },
  },
  {
    path: '/thunder/weapp',
    component: () => import('@/views/other/weapp.vue'),
    name: 'weapp',
    meta: {
      title: '测试h5跳转小程序',
    },
  },
  {
    path: '/thunder/test',
    component: () => import('@/views/other/test/index.vue'),
    name: '测试网络情况',
    meta: {
      title: '测试网络情况',
    },
  },
  {
    path: '/thunder/thunder_gift',
    component: () => import('@/views/goodgift/index.vue'),
    name: 'goodgift',
    meta: {
      title: '包房点餐',
      level: 1,
    },
  },
  {
    path: '/thunder/xiaoai_bless',
    component: () => import('@/views/xiaoai/bless.vue'),
    name: 'xiaoai_bless',
    meta: {
      title: '小爱同学',
    },
  },
  {
    path: '/thunder/lk_test',
    component: () => import('@/views/other/lk-test/index.vue'),
    name: 'lk_test',
    meta: {
      title: '电音舞曲咨询',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/home',
    name: 'lkvip_home',
    component: () => import('@/views/leike/pointer.vue'),
    meta: {
      title: '点歌机VIP已过期',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/pay',
    component: () => import('@/views/leike/vip.vue'),
    name: 'lkvip_pay',
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/paymax',
    component: () => import('@/views/leike/vip_max.vue'),
    name: 'lkvip_pay',
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/paypage',
    component: () => import('@/views/leike/vip_page.vue'),
    name: 'lkvip_pay',
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/pay2',
    component: () => import('@/views/leike/vip2.vue'),
    name: 'lkvip_pay2',
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/agreement',
    component: () => import('@/views/leike/agreement.vue'),
    name: 'lkvip_pay',
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/lkvip/refund',
    component: () => import('@/views/leike/refund.vue'),
    name: 'lkvip_refund',
    meta: {
      title: '点歌机VIP 开通失败',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/qr_pay',
    name: 'qr_pay',
    component: () => import('@/views/vip/vip_toast_pay.vue'),
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/expired',
    component: () => import('@/views/expired/index.vue'),
    name: 'expired',
    meta: {
      title: 'KTV云服务已到期',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/expired_active',
    component: () => import('@/views/expired/active.vue'),
    name: 'expired',
    meta: {
      title: 'KTV云服务已到期',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/game',
    name: 'game',
    component: () => import('@/views/game/index.vue'),
    meta: {
      title: '游戏大厅',
      level: 1,
    },
  },
  ...InteractRoutes,
  ...MineRoutes,
  ...SimpleRoutes,
  ...SongListRoutes,
  ...ValueAddRoutes,
  ...OrderFood,
  ...AiRoutes,
  ...Photo,
  // 广告位弹窗预览面板（CMS 29个广告位 A/B 预览）
  {
    path: '/ad-preview',
    name: 'AdPreview',
    component: () => import('@/views/ad-preview/index.vue'),
    meta: {
      title: '广告位弹窗预览',
      notShowOrderList: true,
    },
  },
  // 弹窗预览沙盒路由（内部工具，所有域名可访问）
  {
    path: '/popup-sandbox',
    name: 'PopupSandbox',
    component: () => import('@/views/popup-sandbox/index.vue'),
    meta: {
      title: '弹窗预览沙盒',
      notShowOrderList: true,
    },
  },
  // 弹窗 AB 方案对比页（内部工具，所有域名可访问）
  {
    path: '/popup-ab-compare',
    name: 'popupAbCompare',
    component: () => import('@/views/popup-ab-compare/index.vue'),
    meta: {
      title: '弹窗 AB 方案对比',
      notShowOrderList: true,
    },
  },
  {
    path: '*',
    redirect: '/thunder/home',
  },
];
